module.exports = __webpack_public_path__ + "static/media/Mage.fc095f12.png";